import React from 'react';

import { TASK_READ_TEXT } from '~/constants/read_const';

import styles from './assets/styles/styles.module.scss';

class TaskComponent extends React.Component {
  constructor(props) {
    super(props);
    this.mainRef = React.createRef();
  }

  async componentDidMount() {
    await this.mainRef.current.scrollIntoView();
    document.documentElement.scrollTop -= 180;
  }

  render() {
    const {
      taskText,
      finishTaskHandler,
    } = this.props;

    const { textIsRead, authorText, authorUnknown } = TASK_READ_TEXT;

    const {
      title,
      text,
      author,
    } = taskText;
    return (
      <div className={styles['task-text']} ref={this.mainRef}>
        <div className={styles['task-wrapper']}>
          <h2 className={styles.text_title}>{title}</h2>
          <h3 className={styles.author}>{`${authorText}: ${author || authorUnknown}`}</h3> 
          <p className={styles.text_itself} dangerouslySetInnerHTML={{__html: text}}></p>
          <button className={`${styles.text_is_read} iq-tests-button`} onClick={finishTaskHandler}>{textIsRead}</button>
        </div>
      </div>
    );
  }
}

export default TaskComponent
